export default __webpack_public_path__ + "static/media/database2.1ff4e61a.svg";